export const tynyshtykova = {
    id: "tynyshtykova",
    name: { ru: "Тыныштыкова Ляззат Елубаевна", kz: "Тыныштықова Ләззат Елубайқызы" },
    position: { ru: "Медицинская сестра общей практики", kz: "Жалпы практика мейіргері" },
    department: "medical-staff",
    image: "/team_photoes/new/Ләззат Елубайқызы.svg",
    experience: {
      ru: "8 лет 1 месяц",
      kz: "8 жыл 1 ай"
    },
    education: {
      ru: `2012–2016 — Кызылординский Республиканский Высший медицинский колледж
2020 — Повышение квалификации по специальности «Сестринское дело, Общие сестринские технологии» (108 часов)`,
      kz: `2012–2016 — Қызылорда Республикалық Жоғары медициналық колледжі
2020 — «Мейірбике ісі, Жалпы мейірбике технологиялары» мамандығы бойынша біліктілікті арттыру (108 сағат)`
    },
    specialization: {
      ru: "Сестринское дело",
      kz: "Мейірбике ісі"
    },
    certificates: {
      ru: `Опыт работы:
С мая 2017 г. – ноябрь 2017 г. — ТОО «RAN Medical», Должность: Медсестра
С декабря 2017 г. – август 2021 г. — РГКП «ЦСМиР», г. Алматы, Должность: Медсестра
С августа 2021 г. – февраль 2022 г. — Городская клиническая инфекционная больница им. И. Жекеновой, Должность: Медсестра
С марта 2022 г. – август 2023 г. — МК «Сункар», Должность: Медсестра

Функциональные обязанности:
• Уход и наблюдение за больными
• Ведение листов назначения и температурных листов; измерение АД
• Сборка и постановка капельных систем
• Выполнение внутривенных и внутримышечных инъекций
• Забор крови и сдача анализов
• Ведение необходимой медицинской документации
• Работа с офисными приложениями (MS Office: Word, Excel)`,
      kz: `Жұмыс тәжірибесі:
2017 ж. мамыр – 2017 ж. қараша — «RAN Medical» ЖШС, Лауазым: Мейірбике
2017 ж. желтоқсан – 2021 ж. тамыз — «ЦСМиР» РМК, Алматы қ., Лауазым: Мейірбике
2021 ж. тамыз – 2022 ж. ақпан — И. Жекенова атындағы қалалық клиникалық жұқпалы аурухана, Лауазым: Мейірбике
2022 ж. наурыз – 2023 ж. тамыз — «Сұңқар» МК, Лауазым: Мейірбике

Функционалдық міндеттер:
• Науқастарға күтім және бақылау
• Тапсырыс парақтары мен температуралық парақтарды жүргізу; қан қысымын өлшеу
• Тамшылық жүйелерді жинау және қою
• Вена іші және бұлшық ет іші инъекцияларын орындау
• Қан алу және талдауларды тапсыру
• Қажетті медициналық құжаттаманы жүргізу
• Кеңсе қосымшаларымен жұмыс (MS Office: Word, Excel)`
    },
    work: {
      ru: `• 2017 — ТОО \"Ran Medical\" – медсестра
• 2017 — 2021 — Национальный центр спортивной медицины и реабилитации – медсестра
• 2021 — 2022 — Городская клиническая инфекционная больница им. И. Жекеновой – медсестра
• 2022 — 2023 — ТОО Медицинская компания «Сункар» – медсестра общей хирургии
      • 2023 — 2025 — РГП на ПХВ "Национальный центр спортивной медицины и реабилитации"
• 2025 — по настоящее время — ГККП "СПОРТИВНЫЙ МЕДИЦИНСКИЙ ЦЕНТР ГОРОДА АСТАНЫ"`,
      kz: `• 2017 — 2021 — Ұлттық спорттық медицина және оңалту орталығы – медбике
• 2021 — 2022 — И.Жекенова атындағы қалалық клиникалық жұқпалы аурулар ауруханасы – медбике
• 2022 — 2023 — «Сұңқар медициналық компаниясы» ЖШС – жалпы хирургия медбикесі
      • 2023 — 2025 — "Ұлттық спорттық медицина және оңалту орталығы" ШЖҚ РМК
• 2025 — қазіргі уақытқа дейін — "Астана қаласының спорттық медицина орталығы" КМК`,
    }
  };
